export default __webpack_public_path__ + "static/media/hero-bose.378bd7c9.webp";